<template>
  <div>
    <div class="row">
      <div class="col-3 border-right">
        <div v-for="group in groupNames" :key="group.id">
          <div style="font-size: 22px;">{{ group }}</div>

          <b-nav vertical class="w-100" card-header pills>
            <b-nav-item @click="swtichTab(item)" :active="item.isActive" v-for="item in fetchTabCategories(group)"
              :key="item.id">{{ item.name }}</b-nav-item>
          </b-nav>
          <hr>
        </div>
      </div>
      <div class="col-9">
        <component :is="selectedComponent" v-if="selectedComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import urlConfig from "../../mixins/url";
import Mill from "./Tabs/Adminitration_Mill";
import DeliveryVehicle from "./Tabs/Adminitration_DeliveryVehicle";
import RawMaterialTypes from "./Tabs/Adminitration_RawMaterialTypes";
import Recipes from "./Tabs/Adminitration_Recipes";
import CreateAccount from "./Tabs/Administration_CreateAccount";
import Producer from "./Tabs/Adminitration_Producer";
import UserAccounts from "./Tabs/Administration_UserAccounts";
import RecipesCoating from "./Tabs/RecipesCoating/Administration_RecipesCoating";
import Barrel from "./Tabs/Adminitration_Barrels";
import CoolingTunnel from "./Tabs/Administration_CoolingTunnel.vue";
import ChocolateSharpener from "./Tabs/Administration_ChocolateSharpener.vue";
import Packing from "./Tabs/Administration_Packing.vue";
import Client from "./Tabs/Adminitration_Client.vue";


const smallProduction = "Hala produkcyjna MAŁA";
const delivery = "Dostawa";
const users = "Użytkownicy";
const bigProduction = "Hala produkcyjna DUŻA";
const packing = "Pakowanie"
const client = "Klienci"

export default {
  components: {
    Mill,
    DeliveryVehicle,
    RawMaterialTypes,
    Recipes,
    CreateAccount,
    Producer,
    UserAccounts,
    RecipesCoating,
    Barrel,
    Packing,
    Client
  },
  mixins: [urlConfig],
  mounted() { },
  data() {
    return {
      groupNames: [delivery, users, smallProduction, bigProduction, packing,client].sort(),

      tabNames: [
        {
          id: 1,
          name: "Produkty",
          group: delivery,
          component: RawMaterialTypes,
          isActive: false,
        },
        {
          id: 2,
          name: "Samochody dostawczwe",
          group: delivery,
          component: DeliveryVehicle,
          isActive: false,
        },
        {
          id: 3,
          name: "Dostawcy",
          group: delivery,
          component: Producer,
          isActive: false,
        },
        {
          id: 4,
          name: "Nowe konto",
          group: users,
          component: CreateAccount,
          isActive: false,
        },
        {
          id: 5,
          name: "Receptury - kuwertury/kremy",
          group: smallProduction,
          component: Recipes,
          isActive: false,
        },
        {
          id: 6,
          name: "Młyny",
          group: smallProduction,
          component: Mill,
          isActive: false,
        },
        {
          id: 7,
          name: "Konta użytkowników",
          group: users,
          component: UserAccounts,
          isActive: false,
        },
        {
          id: 8,
          name: "Receptury - oblewane/tabliczki",
          group: bigProduction,
          component: RecipesCoating,
          isActive: false,
        },
        {
          id: 9,
          name: "Bębny",
          group: bigProduction,
          component: Barrel,
          isActive: false,
        },
        {
          id: 10,
          name: "Tunele chłodnicze",
          group: bigProduction,
          component: CoolingTunnel,
          isActive: false,
        },
        {
          id: 11,
          name: "Temperówki",
          group: bigProduction,
          component: ChocolateSharpener,
          isActive: false,
        },
        {
          id: 12,
          name: "Pakowanie",
          group: packing,
          component: Packing,
          isActive: false,
        },
        {
          id: 12,
          name: "Klienci",
          group: client,
          component: Client,
          isActive: false,
        },
      ],

      selectedComponent: undefined,
    };
  },
  methods: {
    swtichTab(item) {
      this.tabNames.forEach((x) => (x.isActive = false));
      this.selectedComponent = item.component;
      item.isActive = true;
    },
    fetchTabCategories(groupName) {
      return this.tabNames.filter(x => x.group == groupName);
    }
  },
};
</script>